module.exports = __webpack_public_path__ + "assets/img/Fotolia_177579430_XS.adb6e4e4.jpg";